export type OcrStartupStage = 'sdk' | 'cache' | 'worker'
export interface OcrStartupDiagnostic {
  startedAt: string
  elapsedMs: number
  timeoutMs: number
  outcome: 'initializing' | 'ready' | 'error' | 'timeout' | 'cancelled'
  stages: Record<OcrStartupStage, {
    status: 'pending' | 'running' | 'ready' | 'error'
    elapsedMs: number
  }>
  error: { name: string; message: string } | null
}

export class OcrInitializationError extends Error {
  constructor(message: string, readonly diagnostic: OcrStartupDiagnostic) {
    super(message)
    this.name = 'OcrInitializationError'
  }
}

export class OcrInitializationTimeoutError extends OcrInitializationError {
  constructor(diagnostic: OcrStartupDiagnostic) {
    super(`OCR initialization timed out after ${diagnostic.timeoutMs}ms`, diagnostic)
    this.name = 'OcrInitializationTimeoutError'
  }
}
